import { SystemBase } from "@inter-ikea-core/core-toolbox";
import { ComponentIds, } from "@inter-ikea-core/core";
import { COMPONENT_IDS } from "@inter-ikea-storagetwo/range/dist/storage2ComponentIDs";
import { findUniqueConnections } from "../utils/connectorHelpers";
import { resizeChildren } from "../functions/MountingRails";
import { NO_CONNECTION } from "@inter-ikea-storagetwo/range/dist/constants/errors";
import { DELETE } from "@inter-ikea-storagetwo/range/dist/constants";
export default class AutoAdaptChildrenAfterSectionResizeSystem extends SystemBase {
    constructor(_core) {
        super(ComponentIds.GUEST_CONNECTIONS_COMPONENT_ID);
        this._core = _core;
        this.doingChangesOnComponent = [];
        this.systemsBeforeMe = null;
        this.systemsAfterMe = null;
        this.mandatoryComponents = [COMPONENT_IDS.UPRIGHT_COMPONENT];
        this.id = "AutoAdaptChildrenAfterSectionResizeSystem";
    }
    onUpdateComponent(_entity, _oldComponent, _newComponent) {
        super.onUpdateComponent(_entity, _oldComponent, _newComponent);
        const { connections, action } = findUniqueConnections(_newComponent.connections, _oldComponent.connections);
        if (!connections)
            throw new Error(NO_CONNECTION);
        if (action === DELETE ||
            !connections[0].guestConnectorEntity.hasComponent(COMPONENT_IDS.UPRIGHT_COMPONENT))
            return;
        return resizeChildren(this._core, connections[0]);
    }
}
